import { render, staticRenderFns } from "./kitten-sort.vue?vue&type=template&id=09ec118c&"
import script from "./kitten-sort.vue?vue&type=script&lang=js&"
export * from "./kitten-sort.vue?vue&type=script&lang=js&"
import style0 from "./kitten-sort.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/www/xmg-cms-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('09ec118c', component.options)
    } else {
      api.reload('09ec118c', component.options)
    }
    module.hot.accept("./kitten-sort.vue?vue&type=template&id=09ec118c&", function () {
      api.rerender('09ec118c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cats/kitten-sort.vue"
export default component.exports